import http from '@/utils/http';
const base_path = '/v2/tool/deepBidType';

/**
 * 获取深度优化方式接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getDeepBidTypeApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
